import type { TFile } from '../types/common.type';

export type TLLMBlockSelection = { blockId: string; companyId: string };

export enum UploadDocumentJobStatus {
  Initializing = 'initializing',
  Uploading = 'uploading',
  Completed = 'completed',
  Failed = 'failed',
}

export interface UploadFilesParams {
  files: TFile[];
  documentType: string;
  sharedWithCompanyIds: string[];
  label?: string;
  autoTraining?: boolean;
  autoInclude?: boolean;
  folderId?: string;
  expiryDate?: string;
  selectedLLMBlocks?: TLLMBlockSelection[];
}

export interface UploadDocumentProgressData {
  jobId: string;
  status: UploadDocumentJobStatus;
  progress: number;
  total: number;
  currentFile: string;
}

export interface UploadDocumentCompletedData {
  jobId: string;
  successfulFiles: number;
  failedFiles: number;
  totalFiles: number;
  errors?: {
    fileName: string;
    errorCode: string;
    errorData?: any;
  }[];
}

export interface UploadDocumentErrorData {
  jobId: string;
  errorCode: string;
  errorData?: any;
  fileName?: string;
}

export interface UploadDocumentJob extends UploadFilesParams {
  jobId: string;
  companyId: string;
  userId: string;
  status: UploadDocumentJobStatus;
  progress: number;
  total: number;
  currentFile?: string;
  successfulFiles: number;
  failedFiles: number;
  errors: {
    fileName: string;
    errorCode: string;
    errorData?: any;
  }[];
  startedAt: Date;
  completedAt?: Date;
}

export interface UploadDocumentsProgressModalProps extends UploadFilesParams {
  onClose: () => void;
  onComplete: () => void;
}

export interface StartUploadPayload extends UploadFilesParams {
  companyId: string;
}
